import apiClient from './axiosClient';

export const memberApi = {
    searchMembers: async (params) => {
        let memberId = '';
        
        if (params.type.toLowerCase() === "memberid") {
             memberId = params.value;    
        }
        
        const res = await apiClient.get(`/api/provider/member/search?memberId=${memberId}&firstname=${params.firstName}&lastname=${params.lastName}&Birth_Date=${params.dob}&GroupId=${params.groupId}`);

        const data = res?.data;

        

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
      
  // params: { type: 'memberId'|'name', value: string, firstName, lastName, dob }

  getMemberById: (memberId) =>
    apiClient.get(`/members/${memberId}`),
};
